import {
  Component,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  output,
  signal,
  SimpleChange,
  SimpleChanges,
} from "@angular/core";
import { Aul00024Component } from "./aul-000-24/aul-000-24.component";
import { Aul006b24Component } from "./aul-006b-24/aul-006b-24.component";
import { jsPDF } from "jspdf";
import { Aul006a24Component } from "./aul-006a-24/aul-006a-24.component";
import { Cp10540607Component } from "./cp-10-54-06-07/cp-10-54-06-07.component";
import { Cp10331012Component } from "./cp-10-33-10-12/cp-10-33-10-12.component";
import { Aul03424Component } from "./aul-034-24/aul-034-24.component";
import { Aul01924Component } from "./aul-019-24/aul-019-24.component";
import { Cp01400706Component } from "./cp-01-40-07-06/cp-01-40-07-06.component";
import { Cp10751220Component } from "./cp-10-75-12-20/cp-10-75-12-20.component";
import { Il093572Component } from "./il-09-35-07-02/il-09-35-07-02.component";
import { Aul02224Component } from "./aul-022-24/aul-022-24.component";
import { Aul02324Component } from "./aul-023-24/aul-023-24.component";
import { Aul02824Component } from "./aul-028-24/aul-028-24.component";
import { Aul02924Component } from "./aul-029-24/aul-029-24.component";
import { Aul01624Component } from "./aul-016-24/aul-016-24.component";
import { Aul03224Component } from "./aul-032-24/aul-032-24.component";
import { Aul02724Component } from "./aul-027-24/aul-027-24.component";
import { Aul02624Component } from "./aul-026-24/aul-026-24.component";
import { Aul02424Component } from "./aul-024-24/aul-024-24.component";
import { Aul02524Component } from "./aul-025-24/aul-025-24.component";
import { Aul03324Component } from "./aul-033-24/aul-033-24.component";
import { Aul03524Component } from "./aul-035-24/aul-035-24.component";
import { Aul00124Component } from "./aul-001-24/aul-001-24.component";
import { Aul00224Component } from "./aul-002-24/aul-002-24.component";
import { Aul00324Component } from "./aul-003-24/aul-003-24.component";
import { Ilp0010104Component } from "./ilp-001-01-04/ilp-001-01-04.component";
import { Aul00624Component } from "./aul-006-24/aul-006-24.component";
import { Aul00724Component } from "./aul-007-24/aul-007-24.component";
import { Aul00824Component } from "./aul-008-24/aul-008-24.component";
import { Aul00924Component } from "./aul-009-24/aul-009-24.component";
import { Aul01024Component } from "./aul-010-24/aul-010-24.component";
import { Aul01224Component } from "./aul-012-24/aul-012-24.component";
import { Aul01124Component } from "./aul-011-24/aul-011-24.component";
import { Aul01324Component } from "./aul-013-24/aul-013-24.component";
import { Aul01424Component } from "./aul-014-24/aul-014-24.component";
import { Aul01524Component } from "./aul-015-24/aul-015-24.component";
import { Aul01824Component } from "./aul-018-24/aul-018-24.component";
import { Aul03024Component } from "./aul-030-24/aul-030-24.component";
import { Aul03124Component } from "./aul-031-24/aul-031-24.component";
import { Aul02024Component } from "./aul-020-24/aul-020-24.component";
import { Aul02124Component } from "./aul-021-24/aul-021-24.component";
import { Cp00101012Component } from "./cp-00-10-10-12/cp-00-10-10-12.component";
import { Il00171198Component } from "./il-00-17-11-98/il-00-17-11-98.component";
import { CP00900788Component } from "./cp-00-90-07-88/cp-00-90-07-88.component";
import { CP02990607Componet } from "./cp-02-99-06-07/cp-02-99-06-07.component";
import { CP12181012Component } from "./cp-12-18-10-12/cp-12-18-10-12.component";
import { Cp00301012Component } from "./cp-00-30-10-12/cp-00-30-10-12.component";
import { Cp10300917Component } from "./cp-10-30-09-17/cp-10-30-09-17.component";
import { Cp03211012Component } from "./cp-03-21-10-12/cp-03-21-10-12.component";
import { Cp00171012Component } from "./cp-00-17-10-12/cp-00-17-10-12.component";
import { Cp10101012Component } from "./cp-10-10-10-12/cp-10-10-10-12.component";
import { Cp10201012Component } from "./cp-10-20-10-12/cp-10-20-10-12.component";
import { CpEb2025Component } from "./cp-eb-2025/cp-eb-2025.component";
import { Aul03624Component } from "./aul-036-24/aul-036-24.component";
import { Aul03724Component } from "./aul-037-24/aul-037-24.component";
import { Aul03824Component } from "./aul-038-24/aul-038-24.component";
import { Aul03924Component } from "./aul-039-24/aul-039-24.component";
import { Aul04026Component } from "./aul-040-26/aul-040-26.component";
import { PolicyDocumentService } from "../../services/policyDocument.service";
import { Subscription } from "rxjs";
import { AuthService } from "../../auth/auth.service";
import { ToastService } from "../../services/toast.service";
import { ToastType } from "../../enums/config.enum";
import { SpinnerComponent } from "../utils/spinner/spinner.component";
import { AlbamaStateFormComponent } from "./albama-state-form/albama-state-form.component";
import { AlaskaStateFormComponent } from "./alaska-state-form/alaska-state-form.component";
import { ArizonaStateFormComponent } from "./arizona-state-form/arizona-state-form.component";
import { ArkansasStateFormComponent } from "./arkansas-state-form/arkansas-state-form.component";
import { CaliforniaStateFormComponent } from "./california-state-form/california-state-form.component";
import { ColoradoStateFormComponent } from "./colorado-state-form/colorado-state-form.component";
import { ConnecticutStateFormComponent } from "./connecticut-state-form/connecticut-state-form.component";
import { DelawareStateFormComponent } from "./delaware-state-form/delaware-state-form.component";
import { HawaiiStateFormComponent } from "./hawaii-state-form/hawaii-state-form.component";
import { IdahoStateFormComponent } from "./idaho-state-form/idaho-state-form.component";
import { IllinoisStateFormComponent } from "./illinois-state-form/illinois-state-form.component";
import { IndianaStateFormComponent } from "./indiana-state-form/indiana-state-form.component";
import { IowaStateFormComponent } from "./iowa-state-form/iowa-state-form.component";
import { KansasStateFormComponent } from "./kansas-state-form/kansas-state-form.component";
import { KentuckyStateFormComponent } from "./kentucky-state-form/kentucky-state-form.component";
import { LouisianaStateFormComponent } from "./louisiana-state-form/louisiana-state-form.component";
import { MaineStateFormComponent } from "./maine-state-form/maine-state-form.component";
import { MarylandStateFormComponent } from "./maryland-state-form/maryland-state-form.component";
import { MassachusettsStateFormComponent } from "./massachusetts-state-form/massachusetts-state-form.component";
import { MichiganStateFormComponent } from "./michigan-state-form/michigan-state-form.component";
import { MinnesotaStateFormComponent } from "./minnesota-state-form/minnesota-state-form.component";
import { MississippiStateFormComponent } from "./mississippi-state-form/mississippi-state-form.component";
import { MissouriStateFormComponent } from "./missouri-state-form/missouri-state-form.component";
import { MontanaStateFormComponent } from "./montana-state-form/montana-state-form.component";
import { NebraskaStateFormComponent } from "./nebraska-state-form/nebraska-state-form.component";
import { NevadaStateFormComponent } from "./nevada-state-form/nevada-state-form.component";
import { NewHampshireStateFormComponent } from "./new-hampshire-state-form/new-hampshire-state-form.component";
import { NewJerseyStateFormComponent } from "./new-jersey-state-form/new-jersey-state-form.component";
import { NewMexicoStateFormComponent } from "./new-mexico-state-form/new-mexico-state-form.component";
import { NewYorkStateFormComponent } from "./new-york-state-form/new-york-state-form.component";
import { NorthCarolinaStateFormComponent } from "./north-carolina-state-form/north-carolina-state-form.component";
import { NorthDakotaStateFormComponent } from "./north-dakota-state-form/north-dakota-state-form.component";
import { OhioStateFormComponent } from "./ohio-state-form/ohio-state-form.component";
import { OklahomaStateFormComponent } from "./oklahoma-state-form/oklahoma-state-form.component";
import { OregonStateFormComponent } from "./oregon-state-form/oregon-state-form.component";
import { PennsylvaniaStateFormComponent } from "./pennsylvania-state-form/pennsylvania-state-form.component";
import { RhodeIslandStateFormComponent } from "./rhode-island-state-form/rhode-island-state-form.component";
import { SouthCarolinaStateFormComponent } from "./south-carolina-state-form/south-carolina-state-form.component";
import { SouthDakotaStateFormComponent } from "./south-dakota-state-form/south-dakota-state-form.component";
import { TennesseeStateFormComponent } from "./tennessee-state-form/tennessee-state-form.component";
import { UtahStateFormComponent } from "./utah-state-form/utah-state-form.component";
import { VermontStateFormComponent } from "./vermont-state-form/vermont-state-form.component";
import { VirginiaStateFormComponent } from "./virginia-state-form/virginia-state-form.component";
import { WashingtonStateFormComponent } from "./washington-state-form/washington-state-form.component";
import { WestVirginiaStateFormComponent } from "./west-virginia-state-form/west-virginia-state-form.component";
import { WisconsinStateFormComponent } from "./wisconsin-state-form/wisconsin-state-form.component";
import { WyomingStateFormComponent } from "./wyoming-state-form/wyoming-state-form.component";
import { DistrictColumbiaStateFormComponent } from "./district-columbia-state-form/district-columbia-state-form.component";
import { GeorgiaStateFormComponent } from "./georgia-state-form/georgia-state-form.component";
import { TexasStateFormComponent } from "./texas-state-form/texas-state-form.component";
import { response } from "express";
import { EmailDistributionService } from "../../services/email-distribution.service";
import { GetUserDetails } from "../../models/sessionStorage.model";
import { saveAs } from "file-saver";
import { Priv0100622Component } from "./priv-0100-6-22/priv-0100-6-22.component";

@Component({
  selector: "app-policy-documents",
  standalone: true,
  imports: [
    Aul00024Component,
    Aul00124Component,
    Aul00224Component,
    Aul00324Component,
    Ilp0010104Component,
    Aul00724Component,
    Aul00824Component,
    Aul00924Component,
    Aul01224Component,
    Aul00624Component,
    Aul01024Component,
    Aul01124Component,
    Aul02024Component,
    Aul02124Component,
    Aul01524Component,
    Il00171198Component,
    CP00900788Component,
    CP12181012Component,
    Aul01424Component,
    CP02990607Componet,
    Aul01824Component,
    Aul03024Component,
    Aul03124Component,
    Aul006b24Component,
    Aul006a24Component,
    Cp10540607Component,
    Cp10331012Component,
    Aul03424Component,
    Aul01924Component,
    Cp01400706Component,
    Cp10751220Component,
    Il093572Component,
    Aul02224Component,
    Aul02324Component,
    Aul02824Component,
    Aul02924Component,
    Aul01624Component,
    Aul03224Component,
    Aul02724Component,
    Aul02624Component,
    Aul02424Component,
    Aul02524Component,
    Aul03324Component,
    Aul03524Component,
    Aul04026Component,
    Cp00301012Component,
    Cp10300917Component,
    Cp03211012Component,
    Aul01324Component,
    Cp00101012Component,
    Cp00171012Component,
    Cp10101012Component,
    Cp10201012Component,
    CpEb2025Component,
    Aul03624Component,
    Aul03724Component,
    Aul03924Component,
    AlbamaStateFormComponent,
    AlaskaStateFormComponent,
    ArizonaStateFormComponent,
    ArkansasStateFormComponent,
    CaliforniaStateFormComponent,
    ColoradoStateFormComponent,
    ConnecticutStateFormComponent,
    DelawareStateFormComponent,
    HawaiiStateFormComponent,
    SpinnerComponent,
    IdahoStateFormComponent,
    IllinoisStateFormComponent,
    IndianaStateFormComponent,
    IowaStateFormComponent,
    KansasStateFormComponent,
    KentuckyStateFormComponent,
    LouisianaStateFormComponent,
    MaineStateFormComponent,
    MarylandStateFormComponent,
    MassachusettsStateFormComponent,
    MichiganStateFormComponent,
    MinnesotaStateFormComponent,
    MississippiStateFormComponent,
    MissouriStateFormComponent,
    MontanaStateFormComponent,
    NebraskaStateFormComponent,
    NevadaStateFormComponent,
    NewHampshireStateFormComponent,
    NewJerseyStateFormComponent,
    NewMexicoStateFormComponent,
    NewYorkStateFormComponent,
    NorthCarolinaStateFormComponent,
    NorthDakotaStateFormComponent,
    OhioStateFormComponent,
    OklahomaStateFormComponent,
    OregonStateFormComponent,
    PennsylvaniaStateFormComponent,
    RhodeIslandStateFormComponent,
    SouthCarolinaStateFormComponent,
    SouthDakotaStateFormComponent,
    TennesseeStateFormComponent,
    UtahStateFormComponent,
    VermontStateFormComponent,
    VirginiaStateFormComponent,
    WashingtonStateFormComponent,
    WestVirginiaStateFormComponent,
    WestVirginiaStateFormComponent,
    WisconsinStateFormComponent,
    WyomingStateFormComponent,
    DistrictColumbiaStateFormComponent,
    GeorgiaStateFormComponent,
    TexasStateFormComponent,
    Priv0100622Component,
    Aul03824Component,
  ],
  templateUrl: "./policy-documents.component.html",
  styleUrl: "./policy-documents.component.scss",
})
export class PolicyDocumentsComponent implements OnChanges, OnInit, OnDestroy {
  @Input() policyDocDownloadTrigger!: any;
  isGeneratingPDF = signal(false);
  authService = inject(AuthService);
  toastService = inject(ToastService);
  policyDocumentService = inject(PolicyDocumentService);
  policyDetails = signal<any>("");
  policyDocumentSubs = new Subscription();
  policyEmailSubs = new Subscription();
  policyDocDownloadEmitter = output<boolean>();
  downloadEmailCompleteEmitter = output<boolean>();
  policyNo = signal("");
  emailService = inject(EmailDistributionService);
  storageData = signal<GetUserDetails | null>(null);
  userId = signal<string | null>("");
  branchId = signal<string | null>("");
  quoteDetails = signal<any>("");
  pdf: any = "";
  doc: any = "";
  messageEmail: string = "";
  documentFlags: any = {}; // or define a better type if known
  addressState: any;
  currentStateBind: any;


  ngOnInit() {
    this.policyDocumentSubs = this.policyDocumentService
      .getDownloadPolicyDocument()
      .subscribe({
        next: (response: boolean) => {
          if (response) {
            this.getPolicyDocumentDetails("download");
            this.policyDocumentService.setDownloadPolicyDocument(false);
          }
        },
      });

    this.policyEmailSubs = this.policyDocumentService
      .getEmailDocument()
      .subscribe({
        next: (response: boolean) => {
          if (response) {
            this.getPolicyDocumentDetails("email");
            this.policyDocumentService.setEmailDocument(false);
          }
        },
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if(changes['policyDocDownloadTrigger']?.currentValue){
    //   this.toastService.addNotification({message: "Document generation Inprogress", type: ToastType.Info});
    //   this.isGeneratingPDF.set(true);
    //   //this.generatePDFNew(true);
    //   this.pdf.save("Policy_Document.pdf"); // proceed to download the document;
    //   this.isGeneratingPDF.set(false);
    //   this.policyDocDownloadEmitter.emit(true); // reset policyDocDownloadTrigger
    //   this.toastService.addNotification({message: "Document generation Completed", type: ToastType.Success});
    // }
  }

  getPolicyDocumentDetails(type: string) {
    this.policyDocumentService
      .onDownloadPolicyDocument(
        Number(this.authService.getUserDetailsFromStorage()?.policyId),
        Number(this.authService.getUserDetailsFromStorage()?.branchId)
      )
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.toastService.addNotification({
              message: "Document generation In Progress",
              type: ToastType.Info,
            });
            this.policyDetails.set(response[0]); // bind the data
            this.policyNo.set(response[0]?.aul_000_24?.policyNo); 
            
            //state value
            this.addressState = response[0].aul_002_24?.addresses?.[0]?.state ?? '';

            this.currentStateBind = response[0].aul_013_24?.stateId;


            
            // Prepare document flags
              const policy = response[0];
              const addresses = policy?.aul_002_24?.addresses || [];
              const buildings = policy?.aul_002_24?.buildings || [];

              this.documentFlags = {
                isWindExcluded: policy?.aul_002_24?.windDeductibleFlag === 1,
                isTheftExcluded: policy?.aul_002_24?.vandalismDescription === 'Theft Coverage Excluded',
                isWaterDamageExcluded: policy?.aul_002_24?.waterDamageDescription === 'Water Coverage Excluded',
                isBasicForm: ['Basic - RCV', 'Basic - ACV'].includes(policy?.aul_002_24?.causeOfLossDesc),
                isBroadForm: ['Broad - RCV', 'Broad - ACV'].includes(policy?.aul_002_24?.causeOfLossDesc),
                isSpecialForm: ['Special - RCV', 'Special - ACV'].includes(policy?.aul_002_24?.causeOfLossDesc),
                isEqbdSelected: policy?.aul_001_24?.isEQBDSelected === 1,
                isSilverEnhancement: policy?.aul_002_24?.propertyExtCoverageType === 1,
                isGoldEnhancement: policy?.aul_002_24?.propertyExtCoverageType === 2,
                isNonCondo: addresses.some((addr: { occupany: string | string[]; }) => !addr?.occupany?.includes('Condominiums')),
                isCondo: addresses.some((addr: { occupany: string | string[]; }) => addr?.occupany?.includes('Condominiums')),
                ordinanceOrLawIncluded: buildings.some((b: { oandLFlagDescription: string; }) => b?.oandLFlagDescription === 'Ordinance or Law - Included'),
                isCondoWithCertainStates: 
                  ['Condominiums (Up to 20 Condo Units)', 'Condominiums (20+ Condo Units)'].includes(addresses[0]?.occupany) &&
                  [8, 46, 20].includes(policy?.aul_013_24?.stateId),
                isBusinessIncomeLimit: !!policy?.cp_00_30_10_12?.[0],
                hasTRIAAccept: !!policy?.aul_006A_24?.triaAcceptance,
                hasTRIAReject: !!policy?.aul_006B_24?.triaRejection,
                isLossPayee: !!policy?.cp_12_18_10_12,
                isWindStorm: !!policy?.cp_03_21_10_12,
              };
            
            setTimeout(() => {
              this.generatePDF(type);
            }, 0);
          }
        },
        error: (error: any) => {
          this.toastService.addNotification({
            message:
              "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.",
            type: ToastType.Error,
          }); // error notification
        },
      });
  }

  hasOrdinanceOrLawIncluded(): boolean {
    const buildings = this.policyDetails()?.aul_002_24?.buildings || [];
    return buildings.some(
      (building: any) =>
        building?.oandLFlagDescription === 'Ordinance or Law - Included'
    );
  }
  
  isNonCondoAddressPresent(): boolean {
    const addresses = this.policyDetails()?.aul_002_24?.addresses || [];
    return addresses.some(
      (addr: any) =>
        addr?.occupany !== 'Condominiums (Up to 20 Condo Units)' &&
        addr?.occupany !== 'Condominiums (20+ Condo Units)'
    );
  }

  isAnyCondoAddress(): boolean {
    const addresses = this.policyDetails()?.aul_002_24?.addresses || [];
    return addresses.some(
      (addr: any) =>
        addr?.occupany === 'Condominiums (Up to 20 Condo Units)' ||
        addr?.occupany === 'Condominiums (20+ Condo Units)'
    );
  }
  
  
  

  downloadPdfDoc(
    document: any,
    pages: any,
    pageHeight: number,
    pageWidth: number,
    type: any,
    index: number = 0
  ) {
    let footerPdfData: any = {
      aul00024: {
        text: "AUL COMMERCIAL POLICY JACKET 000/26 ",
      },
      aul00124: {
        text: "AUL COMMON POLICY DECLARATIONS 001/24 ",
      },
      aul00224: {
        text: "AUL SUPPLEMENTAL DECLARATIONS 002/24",
      },
      aul00324: {
        text: "AUL POLICY SCHEDULE 003/24 ",
      },
      aul01324: {
        text: "AUL AMENDATORY ENDORSEMENT FLORIDA 013/24",
      },
      "app-aul-013-24-01": {
        text: "CP 01 25 02 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-aul-013-24-02": {
        text: "IL 02 55 03 16",
        center: "© Insurance Services Office, Inc., 2011",
      },
      cp300917: {
        text: "CP 10 30 09 17",
        center: "© Insurance Services Office, Inc., 2016",
      },
      cp181012: {
        text: "CP 12 18 10 12",
        center: "© Insurance Services Office, Inc., 2011 ",
      },
      cp990607: {
        text: "CP 02 99 06 07",
        center: "© ISO Properties, Inc., 2007",
      },
      cp301012: {
        text: "CP 00 30 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      cp211012: {
        text: "CP 03 21 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      aul006b24: {
        text: "AUL TRIA REJECTION 006B/24",
      },
      aul006a24: {
        text: "AUL TRIA COVERAGE 006A/24",
      },
      cp540607: {
        text: "CP 10 54 06 07",
        center: "© ISO Properties, Inc., 2007",
      },
      cp331012: {
        text: "CP 10 33 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      aul03424: {
        text: "AUL WATER DAMAGE 034/24 	",
        textLeft:
          "Includes copyrighted material of Insurance Services Office, Inc.,",
      },
      aul01924: {
        text: "AUL COSMETIC DAMAGE 019/24",
      },
      cp400706: {
        text: "CP 01 40 07 06",
        center: "© ISO Properties, Inc., 2006",
      },
      cp751220: {
        text: "CP 10 75 12 20",
        center: "© Insurance Services Office, Inc., 2020",
      },
      il350702: {
        text: "IL 09 35 07 02",
        center: "© ISO Properties, Inc., 2001",
      },
      aul02224: {
        text: "AUL VIRTUAL CURRENCY 022/24",
      },
      aul02324: {
        text: "AUL WIRING EXCLUSION 023/24",
      },
      aul02824: {
        text: "AUL SICK BUILDING CONDITION(S) 028/24 ",
      },
      aul02924: {
        text: "AUL PRIOR LOSS 029/24",
      },
      aul01624: {
        text: "AUL WAR AND TERRORISM EXCLUSION 016/24",
      },
      aul03224: {
        text: "AUL 2962 032/24 ",
      },
      aul02724: {
        text: "AUL 5019 027/24 ",
      },
      aul02624: {
        text: "AUL 5198 026/24 ",
      },
      aul02424: {
        text: "AUL 2342 024/24 ",
      },
      aul02524: {
        text: "AUL 2341 025/24 ",
      },
      aul03324: {
        text: "AUL ELECTRONIC BIKES AND SCOOTERS 033/24 ",
      },
      aul03524: {
        text: "AUL SOLAR PANEL SYSTEMS 035/24",
      },
      aul00624: {
        text: "AUL TRIA NOTICE 006/24",
      },
      aul00724: {
        text: "AUL SERVICE OF SUIT 007/24",
      },
      aul00824: {
        text: "AUL CLAIMS REPORTING INFORMATION 008/24",
      },
      aul00924: {
        text: "AUL COMPLAINTS NOTICE 009/24",
      },
      aul01024: {
        text: "AUL FRAUD NOTICE 010/24",
      },
      aul01124: {
        text: "AUL INSPECTION NOTICE 011/24",
      },
      aul01224: {
        text: "AUL PRIVACY NOTICE 012/24",
      },
      aul01424: {
        text: "AUL MINIMUM EARNED PREMIUM 014/24",
      },
      aul01524: {
        text: "AUL ORDINANCE OR LAW COVERAGE 015/24",
        textLeft: "Includes Copyrighted material of ISO Properties, Inc.",
      },
      aul01824: {
        text: "AUL ROOF VALUATION 018/24",
      },
      aul02024: {
        text: "AUL PROPERTY ENHANCEMENT ENDORSEMENT 020/24 ",
      },
      aul02124: {
        text: "AUL PROPERTY ENHANCEMENT ENDORSEMENT 021/24 ",
      },
      aul03024: {
        text: "AUL PROTECTIVE SAFEGUARDS 030/24",
        textLeft:
          "Includes copyrighted material of Insurance Services Office, Inc.,",
      },
      aul03124: {
        text: "AUL BR PROTECTIVE SAFEGUARDS 031/24",
        textLeft:
          "Includes copyrighted material of Insurance Services Office, Inc.,",
      },
      ilp010104: {
        text: "IL P 001 01 04",
        center: "© ISO Properties, Inc., 2004",
      },
      il171198: {
        text: "IL 00 17 11 98",
        center: "Copyright, Insurance Services Office, Inc., 1998",
      },
      cp101012: {
        text: "CP 00 10 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      cp171012: {
        text: "CP 00 17 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      cp10101012: {
        text: "CP 10 10 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      cp201012: {
        text: "CP 10 20 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      aul03624: {
        text: "AUL EIFS EXCLUSION 036/24",
      },
      aul03724: {
        text: "AUL 5018 037/24",
      },
      cp900788: {
        text: "CP 00 90 07 88",
        center: "Copyright, ISO Commercial Risk Services, Inc., 1983, 1987",
      },
      aul04026: {
        text: "AUL EQUIPMENT BREAKDOWN COVERAGE NOTICE 040/26	"
      }
    };
    const policyNoPdf = sessionStorage.getItem("policyNo");
    const nameInsuredPdf = sessionStorage.getItem("nameInsured");
    const hasPages = pages.length > 0;
    const self = this;
    if (!hasPages) {
      const totalPages = document.getNumberOfPages();
      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
        document.setPage(pageNumber);
        document.setFontSize(8);
        document.setTextColor("black");
        document.text(
          `Page ${pageNumber} of ${totalPages}`,
          pageWidth - 10,
          pageHeight - 10,
          {
            align: "right",
          }
        );
      }
      this.isGeneratingPDF.set(false);
      if (type === "download") {
        self.toastService.addNotification({
          message: "Document download Completed",
          type: ToastType.Success,
        });
        return document.save(
          "Policy_" + policyNoPdf + "_" + nameInsuredPdf + ".pdf"
        );
      } else {
        let base = document.output("datauristring");
        self.SendEmail(base);
      }
    }

    return document.html(pages[0], {
      callback(pdf: any) {
        const pdfPageId = pages[0].getAttribute("id");
        let footerDataVal = footerPdfData[pdfPageId];
        const safeFooterText = (value: any): string =>
          String(value ?? "").replace(/\t/g, " ").trim();

        if (footerDataVal) {
          // Always force a predictable footer font to avoid inherited glyph spacing issues.
          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(8);

          if (footerDataVal.textLeft) {
            pdf.text(safeFooterText(footerDataVal["text"]), 10, pageHeight - 20, {
              align: "left",
              maxWidth: pageWidth - 20,
            });
            pdf.setFontSize(8);
            pdf.setFont("helvetica", "italic");
            pdf.text(safeFooterText(footerDataVal["textLeft"]), 10, pageHeight - 10, {
              align: "left",
              maxWidth: pageWidth - 20,
            });
          } else {
            pdf.text(safeFooterText(footerDataVal["text"]), 10, pageHeight - 10, {
              align: "left",
              maxWidth: pageWidth - 20,
            });
          }

          if (footerDataVal.center) {
            pdf.setFontSize(12);
            pdf.setFont("helvetica", "normal");
            pdf.text(
              safeFooterText(footerDataVal.center),
              pageWidth / 2,
              pageHeight - 10,
              {
                align: "center",
                maxWidth: pageWidth - 20,
              }
            );
          }
        }
        if (index > 0 && pages.length > 1) pdf.addPage("a4");
        const restPages = pages.slice();
        restPages.splice(0, 1);
        self.downloadPdfDoc(
          pdf,
          restPages,
          pageHeight,
          pageWidth,
          type,
          index + 1
        );
      },
      y: index * (pageHeight - 40),
      margin: [20, 20, 20, 20],
      width: pageWidth - 40,
      windowWidth: 760,
      autopaging: "text",
    });
  }

  async generatePDFNew1(type: string): Promise<void> {
    this.isGeneratingPDF.set(true);
    var allPdfPages: any = [
      "aul00024",
      "alaska1324",
      "alabama1324",
      "arizona1324",
      "arikansas1324",
      "california1324",
      "colorado1324",
      "connecticut1324",
      "delware1324",
      "columbia1324",
      "aul01324",
      "georgia1324",
      "hawaii1324",
      "idaho1324",
      "illinois1324",
      "indiana1324",
      "iowa1324",
      "kansas1324",
      "kentucky1324",
      "louisiana1324",
      "maine1324",
      "maryland1324",
      "massachusetts1324",
      "michigan1324",
      "minnesota1324",
      "mississippi1324",
      "missouri1324",
      "montana1324",
      "nebraska1324",
      "nevada1324",
      "newhampshire1324",
      "newjersey1324",
      "newmexico1324",
      "newyork1324",
      "northcarolina1324",
      "northdakota1324",
      "ohio1324",
      "oklahoma1324",
      "oregon1324",
      "pennsylvania1324",
      "rhode1324",
      "southcarolina1324",
      "southdakota1324",
      "tennessee1324",
      "texas1324",
      "utah1324",
      "vermont1324",
      "virginia1324",
      "washington1324",
      "westvirginia1324",
      "wisconsin1324",
      "wyoming1324",
      "aul00124",
      "aul00224",
      "aul00324",
      "ilp010104",
      "aul00824",
      "aul00924",
      "aul01224",
      "aul00624",
      "aul01024",
      "aul01124",
      "cp001012",
      "cp171012",
      "cp301012",
      "cp10101012",
      "cp300917",
      "cbeb2025",
      "cp101012",
      "cp201012",
      "aul02024",
      "aul02124",
      "aul01524",
      "il171198",
      "cp900788",
      "cp181012",
      "aul01424",
      "cp990607",
      "aul01824",
      "cp211012",
      "aul03024",
      "aul03124",
      "aul006b24",
      "aul006a24",
      "cp540607",
      "cp331012",
      "aul03424",
      "aul01924",
      "cp400706",
      "cp751220",
      "il350702",
      "aul02224",
      "aul02924",
      "aul01624",
      "aul03224",
      "aul02724",
      "aul02624",
      "aul02424",
      "aul02524",
      "aul03524",
      "aul03724",
      "aul04026"
    ];
    let filteredPdfPages: any = allPdfPages.filter(function (item: any) {
      return document.getElementById(item);
    });

    filteredPdfPages = filteredPdfPages?.map((i: any) => {
      return document.getElementById(i);
    });
    let doc = new jsPDF("p", "pt", "a4", true);
    let pageHeight = doc.internal.pageSize.getHeight();
    let pageWidth = doc.internal.pageSize.width;
    var pageCount = doc.internal.pages.length - 1;
    this.downloadPdfDoc(doc, filteredPdfPages, pageHeight, pageWidth, type);
    /*
    this.isGeneratingPDF.set(true);
    let pdf = new jsPDF("p", "pt", "a4", true);
    let pageHeight = pdf.internal.pageSize.getHeight();
    let pageWidth = pdf.internal.pageSize.width;
    let messageDoc = this.messageEmail;
    let numberOfPages = pdf.getNumberOfPages();
    const pages: any = document.getElementById("pdf-pages")?.innerHTML;
    let pdfPolicyNo = this.policyNo();
    const self = this;

    pdf.html(pages, {
      callback: function (doc) {
        self.isGeneratingPDF.set(true);
        const totalPages = doc.getNumberOfPages();
        for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
          doc.setPage(pageNumber);
          doc.setFontSize(8);
          doc.setTextColor("black");
          doc.text(
            `Page: ${pageNumber}/${totalPages}`,
            10,
            doc.internal.pageSize.height - 5
          );
        }
        self.isGeneratingPDF.set(false);
        
        if(type === "download"){
          pdf.save("Policy Document_" + pdfPolicyNo + ".pdf");
          self.toastService.addNotification({
            message: "Document generation Completed",
            type: ToastType.Success,
          });
        }else{
          var base = pdf.output('datauristring');          
          self.SendEmail(base);
        }

       
      },
      margin:[20,20,20,20],
      width: pageWidth-40,
      windowWidth: 760
    });

    */
  }

  SendEmail(base64Document: string) {
    const storageData = this.authService.getUserDetailsFromStorage();
    this.storageData.set(storageData);
    this.userId.set(String(storageData?.userDetails?.userId));
    this.branchId.set(String(storageData?.branchId));
    const policyNo = sessionStorage.getItem("policyNo");
    const userEmail = sessionStorage.getItem("userEmail");
    const nameInsured = sessionStorage.getItem("nameInsured");
    const payload = {
      userId: this.userId(),
      policyNo: policyNo,
      policyName: nameInsured,
      branchId: this.branchId(),
      type: "Policy",
      toEmail: userEmail,
      documentData: `${base64Document}`,
    };

    this.emailService.SendEmailDistribution(payload).subscribe({
      next: (response: any) => {
        if (response) {
          const emailRes = response.message.replace(/["']/g, "");

          this.toastService.addNotification({
            message: "Email Sent Successfully",
            type: ToastType.Success,
          });
        }
      },

      error: (error: any) => {},
    });
  }

  setDocumentLoader(data: boolean) {
    this.isGeneratingPDF.set(data);
  }

  async generatePDF(type: string): Promise<void> {
    this.isGeneratingPDF.set(true);
    let pdf = new jsPDF("p", "pt", "a4", true);
    let pageHeight = pdf.internal.pageSize.getHeight();
    let pageWidth = pdf.internal.pageSize.width;
    const sanitizeFooterText = (value: any): string => {
      const joinLettersWithSubtleSpacing = (token: string): string => {
        const chars = token.split("");
        const sep = "\u2009";
        return chars.reduce((acc, ch, i) => {
          if (i === 0) {
            return ch;
          }
          const prev = chars[i - 1];
          // Avoid extra-wide visual gaps for A+N / A+U pairs in condensed PDF caps.
          if (
            String(prev).toUpperCase() === "A" &&
            (String(ch).toUpperCase() === "N" || String(ch).toUpperCase() === "U" || String(ch).toUpperCase() === "T" || String(ch).toUpperCase() === "G" || String(ch).toUpperCase() === "R")
          ) {
            return acc + ch;
          }
          return acc + sep + ch;
        }, "");
      };

      const normalized = String(value ?? "")
        .normalize("NFKC")
        .replace(/[\u00AD\u200B-\u200D\uFEFF]/g, "")
        .replace(/\t/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        // Accidental break inside "ENHANCEMENT" becomes a false word boundary after NBSP expansion.
        .replace(/ENHA\s+NCEMENT/gi, "ENHANCEMENT");

      // Keep visible word gaps in renderers that collapse/condense regular spaces.
      const withWordSpacing = normalized.replace(/ /g, "\u00A0\u00A0");
      // Subtle per-letter spacing to avoid overlap without wide gaps.
      return withWordSpacing
        .split("\u00A0\u00A0")
        .map((token) => joinLettersWithSubtleSpacing(token))
        .join("\u00A0\u00A0");
    };

    let footerData: any = {
      "app-aul-000-24": {
        text: "AUL COMMERCIAL POLICY JACKET 000/26 ",
      },
      "app-aul-001-24": {
        text: "AUL COMMON POLICY DECLARATIONS 001/24 ",
      },
      "app-aul-002-24": {
        text: "AUL SUPPLEMENTAL DECLARATIONS 002/24",
      },
      "app-aul-003-24": {
        text: "AUL POLICY SCHEDULE 003/24 ",
      },
      "app-aul-013-24": {
        text: "AUL AMENDATORY ENDORSEMENT " + this.addressState.toUpperCase() + " 013/24",
      },
      "app-aul-013-24-01": {
        text: "CP 01 25 02 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-aul-013-24-02": {
        text: "IL 02 55 03 16",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-cp-10-30-09-17": {
        text: "CP 10 30 09 17",
        center: "© Insurance Services Office, Inc., 2016",
      },
      "app-cb-eb-2025": {
        text: "AUL EQUIPMENT BREAKDOWN ENHANCEMENT ENDORSEMENT CP EB 2025"
      },
      "app-aul-040-26": {
        text: "AUL EQUIPMENT BREAKDOWN COVERAGE NOTICE 040/26	"
      },
      "app-cp-12-18-10-12": {
        text: "CP 12 18 10 12",
        center: "© Insurance Services Office, Inc., 2011 ",
      },
      "app-cp-02-99-06-07": {
        text: "CP 02 99 06 07",
        center: "© ISO Properties, Inc., 2007",
      },
      "app-cp-00-30-10-12": {
        text: "CP 00 30 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-cp-03-21-10-12": {
        text: "CP 03 21 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-aul-006b-24": {
        text: "AUL TRIA REJECTION 006B/24",
      },
      "app-aul-006a-24": {
        text: "AUL TRIA COVERAGE 006A/24",
      },
      "app-cp-10-54-06-07": {
        text: "CP 10 54 06 07",
        center: "© ISO Properties, Inc., 2007",
      },
      "app-cp-10-33-10-12": {
        text: "CP 10 33 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-aul-034-24": {
        text: "AUL WATER DAMAGE 034/24 	",
        textLeft:
          "Includes copyrighted material of Insurance Services Office, Inc.,",
      },
      "app-aul-019-24": {
        text: "AUL COSMETIC DAMAGE 019/24",
      },
      "app-cp-01-40-07-06": {
        text: "CP 01 40 07 06",
        center: "© ISO Properties, Inc., 2006",
      },
      "app-cp-10-75-12-20": {
        text: "CP 10 75 12 20",
        center: "© Insurance Services Office, Inc., 2020",
      },
      "app-il-09-35-07-02": {
        text: "IL 09 35 07 02",
        center: "© ISO Properties, Inc., 2001",
      },
      "app-aul-022-24": {
        text: "AUL VIRTUAL CURRENCY 022/24",
      },
      "app-aul-023-24": {
        text: "AUL WIRING EXCLUSION 023/24",
      },
      "app-aul-028-24": {
        text: "AUL SICK BUILDING CONDITION(S) 028/24 ",
      },
      "app-aul-029-24": {
        text: "AUL PRIOR LOSS 029/24",
      },
      "app-aul-016-24": {
        text: "AUL WAR AND TERRORISM EXCLUSION 016/24",
      },
      "app-aul-032-24": {
        text: "AUL 2962 032/24 ",
      },
      "app-aul-027-24": {
        text: "AUL 5019 027/24 ",
      },
      "app-aul-026-24": {
        text: "AUL 5198 026/24 ",
      },
      "app-aul-024-24": {
        text: "AUL 2342 024/24 ",
      },
      "app-aul-025-24": {
        text: "AUL 2341 025/24 ",
      },
      "app-aul-033-24": {
        text: "AUL ELECTRONIC BIKES AND SCOOTERS 033/24 ",
      },
      "app-aul-035-24": {
        text: "AUL SOLAR PANEL SYSTEMS 035/24",
      },
      "app-aul-006-24": {
        text: "AUL TRIA NOTICE 006/24",
      },
      "app-aul-007-24": {
        text: "AUL SERVICE OF SUIT 007/24",
      },
      "app-aul-008-24": {
        text: "AUL CLAIMS REPORTING INFORMATION 008/24",
      },
      "app-aul-009-24": {
        text: "AUL COMPLAINTS NOTICE 009/24",
      },
      "app-aul-010-24": {
        text: "AUL FRAUD NOTICE 010/24",
      },
      "app-aul-011-24": {
        text: "AUL INSPECTION NOTICE 011/24",
      },
      "app-aul-012-24": {
        text: "AUL PRIVACY NOTICE 012/24",
      },
      "app-aul-014-24": {
        text: "AUL MINIMUM EARNED PREMIUM 014/24",
      },
      "app-aul-015-24": {
        text: "AUL ORDINANCE OR LAW COVERAGE 015/24",
        textLeft: "Includes Copyrighted material of ISO Properties, Inc.",
      },
      "app-aul-018-24": {
        text: "AUL ROOF VALUATION 018/24",
      },
      "app-aul-020-24": {
        text: "AUL PROPERTY ENHANCEMENT ENDORSEMENT 020/24 ",
      },
      "app-aul-021-24": {
        text: "AUL PROPERTY ENHANCEMENT ENDORSEMENT 021/24 ",
      },
      "app-aul-030-24": {
        text: "AUL PROTECTIVE SAFEGUARDS 030/24",
        textLeft:
          "Includes copyrighted material of Insurance Services Office, Inc.,",
      },
      "app-aul-031-24": {
        text: "AUL BR PROTECTIVE SAFEGUARDS 031/24",
        textLeft:
          "Includes copyrighted material of Insurance Services Office, Inc.,",
      },
      "app-ilp-001-01-04": {
        text: "IL P 001 01 04",
        center: "© ISO Properties, Inc., 2004",
      },
      "app-il-00-17-11-98": {
        text: "IL 00 17 11 98",
        center: "Copyright, Insurance Services Office, Inc., 1998",
      },
      "app-cp-00-10-10-12": {
        text: "CP 00 10 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-cp-00-17-10-12": {
        text: "CP 00 17 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-cp-10-10-10-12": {
        text: "CP 10 10 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-cp-10-20-10-12": {
        text: "CP 10 20 10 12",
        center: "© Insurance Services Office, Inc., 2011",
      },
      "app-aul-036-24": {
        text: "AUL EIFS EXCLUSION 036/24",
      },
      "app-aul-037-24": {
        text: "AUL 5018 037/24",
      },
      "app-cp-00-90-07-88": {
        text: "CP 00 90 07 88",
        center: "Copyright, ISO Commercial Risk Services, Inc., 1983, 1987",
      },
      "app-priv-0100-6-22": {
        text: "PRIV-0100 6/22"
      },
      "app-aul-039-24":{
        text: "AUL HEAT MAINTENANCE PROTECTIVE SAFEGUARDS 039/24",
        textLeft:
        "Includes copyrighted material of Insurance Services Office, Inc.,"
      },
      "app-aul-038-24":{
        text: "AUL CONDOMINIUM COVERAGE EXTENSION 038/24",
        textLeft:
        "Includes Copyrighted material of ISO Properties, Inc."
      },
      
    };
    Object.keys(footerData).forEach((key) => {
      const item = footerData[key];
      if (!item) {
        return;
      }
      if (item.text !== undefined) {
        item.text = sanitizeFooterText(item.text);
      }
      if (item.textLeft !== undefined) {
        item.textLeft = sanitizeFooterText(item.textLeft);
      }
      if (item.center !== undefined) {
        item.center = sanitizeFooterText(item.center);
      }
    });

    let formDataArr = [];
    const pages = document.querySelectorAll(".pdf-page");

    /** Loop 1 - Page Break**/
    for (let i = 0; i < pages.length; i++) {
      let numberOfPages = pdf.getNumberOfPages();

      let className: string =
        pages[i].className
          .split(" ")
          .find((className) => className.startsWith("app-")) || "";

      /* await pdf.html(pages[i] as HTMLElement, {
        callback: function (pdf2: any) {
          return pdf2;
        },
        y: i ? numberOfPages * pageHeight + 20 : 20,
        autoPaging: "text",
        x: 20,
        width: pageWidth - 40,
        windowWidth: 800,
      });*/

      let currentPdfStartPage = pdf.getNumberOfPages();
      if (i && footerData[className]) {
        footerData[className] = {
          ...footerData[className],
          start: footerData[className]["start"]
            ? footerData[className]["start"]
            : numberOfPages + 1,
          end: currentPdfStartPage,
        };
      } else {
        footerData[className] = {
          ...footerData[className],
          start: 1,
          end: currentPdfStartPage
        };
      }

      const formDataObj = {
        formName: className,
        formData: JSON.parse(JSON.stringify(pages[i].innerHTML)),
        formFooter: footerData[className],
      };
      if(className != ''){
      formDataArr.push(formDataObj);
      }
    }

    if(type === "download"){
    this.policyDocumentService.downloadPdf(formDataArr).subscribe(
      (blob) => {
        const policyNoPdf = sessionStorage.getItem("policyNo");
        const nameInsuredPdf = sessionStorage.getItem("nameInsured");
        const documentName =
          "Policy_" + policyNoPdf + "_" + nameInsuredPdf + ".pdf";
        saveAs(blob, documentName);
        this.toastService.addNotification({
          message: "Document download Completed",
          type: ToastType.Success,
        });
        // Update download/email complete flag after successful download       
        
        const policyNo = sessionStorage.getItem("policyNo");
    const userEmail = sessionStorage.getItem("userEmail");
    const nameInsured = sessionStorage.getItem("nameInsured");
    const payload = {
      formDataList: formDataArr,     
      document: {
        toEmail: userEmail,
        docNo: policyNo,
        docType: 'Policy',
        docName: nameInsured,    
       }
    };
    this.policyDocumentService.emailPdf(payload).subscribe({
      next: (response: any) => {
       this.updateDownloadEmailCompleteFlag();
      },
      error: (error) => {
      }
    });
      },
      (error) => {}   
    );
  }else{
    const policyNo = sessionStorage.getItem("policyNo");
    const userEmail = sessionStorage.getItem("userEmail");
    const nameInsured = sessionStorage.getItem("nameInsured");
    const payload = {
      formDataList: formDataArr,     
      document: {
        toEmail: userEmail,
        docNo: policyNo,
        docType: 'Policy',
        docName: nameInsured,    
       }
    };
    this.policyDocumentService.emailPdf(payload).subscribe({
      next: (response: any) => {
        this.toastService.addNotification({
          message: "Email Sent Sucessfully",
          type: ToastType.Success,
        });
        // Update download/email complete flag after successful email
        this.updateDownloadEmailCompleteFlag();
      },
      error: (error) => {
      }
    });
  }
    this.isGeneratingPDF.set(false);

    //const policyNoPdf = sessionStorage.getItem('policyNo');
    // const nameInsuredPdf = sessionStorage.getItem('nameInsured');
    if (type === "download") {
      //pdf.save(("Policy_" + policyNoPdf + "_"+nameInsuredPdf+".pdf"));
    } else {
      let base = pdf.output("datauristring");
      // this.SendEmail(base);
    }
  }

  async generatePDFPGBreak(): Promise<void> {
    this.isGeneratingPDF.set(true);
    let pdf = new jsPDF("p", "pt", "a4", true);
    let pageHeight = pdf.internal.pageSize.getHeight();
    let pageWidth = pdf.internal.pageSize.width;

    const htmlContentElement = document.querySelectorAll(".pdf-page");
    if (htmlContentElement.length === 0) {
      console.error("No elements found with the selector #pdf-pages");
      return;
    }

    //const htmlContent = htmlContentElement.innerHTML;
    const chunks = await this.splitContentIntoChunks(
      htmlContentElement,
      pageHeight,
      pageWidth
    );
    // Process chunks in batches
    const batchSize = 5; // Adjust batch size as needed

    for (let i = 0; i < chunks.length; i += batchSize) {
      const batch = chunks.slice(i, i + batchSize);

      await Promise.all(
        batch.map((chunk, index) => {
          return new Promise<void>((resolve, reject) => {
            let pageIndex = i + index;
            if (pageIndex > 0) {
              pdf.addPage();
            }

            const chunkElement = document.createElement("div");
            chunkElement.innerHTML = chunk;
            document.body.appendChild(chunkElement);

            pdf
              .html(chunkElement, {
                x: 20,
                y: 20,
                width: pageWidth - 40,
                windowWidth: 800,
                callback: function (pdf2: any) {
                  document.body.removeChild(chunkElement);
                  resolve(); // Ensure the promise resolves after processing
                  return pdf2;
                },
              })
              .catch((error) => {
                console.error(`Error processing chunk ${pageIndex}:`, error);
                document.body.removeChild(chunkElement);
                reject(error);
              });
          });
        })
      );
    }

    this.isGeneratingPDF.set(false);
    pdf.save(`${this.policyNo()}.pdf`);
    this.toastService.addNotification({
      message: "Document generation Completed",
      type: ToastType.Success,
    });
  }

  async splitContentIntoChunks(
    htmlContentElements: any,
    pageHeight: number,
    pageWidth: number
  ): Promise<string[]> {
    const chunks: string[] = [];
    let currentChunk = "";
    let currentHeight = 0;

    for (const element of htmlContentElements) {
      const elementHeight = await this.getElementHeight(element, pageWidth);
      console.log(
        "ELE HEIGHT",
        elementHeight,
        "PGHEight",
        pageHeight,
        "cond",
        currentHeight + elementHeight + elementHeight
      );
      // Check if adding this element exceeds the page height
      if (currentHeight + elementHeight > pageHeight) {
        if (currentChunk) {
          console.log("Pushing current chunk:", currentChunk);
          chunks.push(currentChunk);
        }
        // Start a new chunk with the current element
        currentChunk = element.outerHTML;
        currentHeight = elementHeight;
      } else {
        // Add the element to the current chunk
        currentChunk += element.outerHTML;
        currentHeight += elementHeight;
      }
    }
    // Push any remaining chunk
    if (currentChunk.trim()) {
      chunks.push(currentChunk);
    }

    return chunks;
  }

  async getElementHeight(element: Element, pageWidth: number): Promise<number> {
    const clone = element.cloneNode(true) as HTMLElement;
    clone.style.width = `${pageWidth}px`;
    clone.style.position = "absolute";
    clone.style.visibility = "hidden";
    document.body.appendChild(clone);

    const height = clone.offsetHeight;
    document.body.removeChild(clone);

    return height;
  }

  updateDownloadEmailCompleteFlag() {
    const storageData = this.authService.getUserDetailsFromStorage();
    const policyId = storageData?.policyId;
    const userId = storageData?.userDetails?.userId;
    
    if (policyId && userId) {
      this.policyDocumentService.UpdateIsDownloadEmailComplete(
        Number(policyId),
        Number(userId),
        1
      ).subscribe({
        next: (response: any) => {
          // Flag updated successfully - emit event to parent component
          this.downloadEmailCompleteEmitter.emit(true);
        },
        error: (error: any) => {
          // Handle error silently or log if needed
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.policyDocumentSubs?.unsubscribe();
    this.policyEmailSubs?.unsubscribe();
  }
}
